import { errorToast, toast } from "@/v2-ui/toast"
import FeatureDetailsHotfixTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsHotfixTexts"
import { useNavLayerUpdateMutation } from "@/v2-backoffice-client/navlayer/update/navlayer.update.mutation"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerViewDetailsHotfixTextsProps = {
  navLayer: NavLayerFragment
}

/** Binds the shared hotfix text form to the nav layer's runtime update. */
function NavLayerViewDetailsHotfixTexts(
  props: NavLayerViewDetailsHotfixTextsProps,
) {
  const { navLayer } = props

  const [updateNavLayer, updateState] = useNavLayerUpdateMutation()
  errorToast(updateState.error, { title: "Failed to update nav layer texts" })

  async function onSave(texts: { name: string; description: string | null }) {
    const result = await updateNavLayer({
      variables: {
        input: {
          FeatureCode: navLayer.FeatureCode,
          Name: texts.name,
          Description: texts.description,
        },
      },
    })
    if (result.data) {
      toast({ title: "Nav layer texts saved to the live runtime." })
    }
  }

  return (
    <FeatureDetailsHotfixTexts
      name={navLayer.Name}
      description={navLayer.Description ?? ""}
      isSaving={updateState.loading}
      featureCodeLabel="NavLayers"
      onSave={(texts) => void onSave(texts)}
    />
  )
}

export default NavLayerViewDetailsHotfixTexts
